import React from "react";
import { Grid, Typography, Button, Box } from "@mui/material";
import bgimage from "../Images/autobg2.png";

const features = [
  {
    title: "Automated Docker Files",
    description: "Witness the era of effortless Docker file generation.",
  },
  {
    title: "Streamlined Deployment",
    description: "Redefining deployment configurations for unparalleled simplicity.",
  },
  {
    title: "Customized Pipelines",
    description: "Tailored pipeline configurations that align seamlessly with your chosen provider.",
  },
  {
    title: "OpenAI Integration",
    description: "A revolutionary leap into intelligent automation.",
  },
];

const Page2 = () => {
  return (
    <Box
      sx={{
        backgroundImage: `url(${bgimage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        px: { xs: 3, sm: 4, md: 6 },
        textAlign: "center",
        width: "100vw",
        maxWidth: "100%",
        py: 6,
      }}
    >
      <Typography variant="h3" sx={{fontFamily:'Montserrat', color: "#fff", fontWeight: "bold", fontSize: { xs: "28px", sm: "32px", md: "36px" }, mb: 4 }}>
        Kubernetes Deployment and Pipelines Revolution
        <Box sx={{ width: "288px", height: "8px", backgroundColor: "#FAD32E", margin: "12px auto 0 auto", borderRadius: "2px" }} />
      </Typography>

      <Box sx={{ backgroundColor: "rgba(51, 68, 93, 0.8)", color: "#fff", padding: "24px", borderRadius: "10px", textAlign: "center", maxWidth: "1000px", mb: 5 }}>
        <Typography variant="body1" sx={{ fontFamily:'Montserrat',fontSize: { xs: "14px", sm: "16px", md: "18px" } }}>
          The "Auto CI-CD Generator" is not just another tool; it's a revolutionary force in Kubernetes deployment and pipeline management. Driven by OpenAI technology, this Python-based application redefines the deployment process, focusing on user-friendliness.
        </Typography>
      </Box>

      <Typography variant="h5" sx={{ fontFamily:'Montserrat',color: "#fff", fontWeight: "bold", fontSize: { xs: "20px", sm: "24px", md: "26px" }, mb: 2 }}>
        Key Features
        <Box sx={{ width: "80px", height: "4px", backgroundColor: "#FAD32E", margin: "8px auto 0 auto", borderRadius: "2px" }} />
      </Typography>

      <Grid container spacing={3} justifyContent="center" sx={{ maxWidth: "1100px", mt: 3, px: 2 }}>
        {features.map((feature, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Box sx={{ backgroundColor: "rgba(51, 68, 93, 0.9)", color: "#fff", padding: "20px", borderRadius: "10px", textAlign: "center", minHeight: "250px" }}>
              <Typography variant="h6" sx={{ fontFamily:'Montserrat',fontWeight: "bold", color: "white", fontSize: { xs: "18px", sm: "20px" }, mb: 1 ,textAlign:'left'}}>
                {feature.title}
              </Typography>
              <Typography variant="body2" sx={{ fontSize: { xs: "16px", sm: "18px",textAlign:'left' } }}>
                {feature.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Typography variant="h5" sx={{fontFamily:'Montserrat', color: "#fff", fontWeight: "bold", fontSize: { xs: "20px", sm: "24px", md: "26px" }, mt: 6, mb: 2 }}>
        Ready to Revolutionize Kubernetes Deployments and Pipelines?
        <Box sx={{ width: "80px", height: "4px", backgroundColor: "#FAD32E", margin: "8px auto 0 auto", borderRadius: "2px" }} />
      </Typography>
      
      <Box sx={{ backgroundColor: "rgba(51, 68, 93, 0.8)", color: "#fff", padding: "24px", borderRadius: "10px", textAlign: "center", maxWidth: "1000px", mb: 5 }}>
        <Typography variant="body1" sx={{ fontFamily:'Montserrat',fontSize: { xs: "14px", sm: "16px" } }}>
          The "Auto CI-CD Generator" is not just another tool; it's a revolutionary force in Kubernetes deployment and pipeline management. Driven by OpenAI technology, this Python-based application redefines the deployment process.
        </Typography>
      </Box>

      {/* <Button variant="contained" sx={{fontFamily:'Montserrat', backgroundColor: "#FAD32E", color: "#000", fontWeight: "bold", fontSize: { xs: "14px", sm: "16px" }, px: { xs: 3, sm: 4 }, py: { xs: 1.5, sm: 2 }, borderRadius: "15px", width: { xs: "80%", sm: "auto" ,md:'20%'}, "&:hover": { backgroundColor: "black",color:'#FAD32E',borderColor:'#FAD32E' } }}>
        TRY NOW
      </Button> */}
    </Box>
  );
};

export default Page2;
